/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */
import * as Blockly from 'blockly/core';
import 'blockly/python';
import { getAllowedOutputs } from '../block_compatibility_checks';

Blockly.Blocks['output_table'] = {
    init: function () {
        this.appendDummyInput()
            .appendField("Table");
        this.setPreviousStatement(true, 'presentation');
        this.setNextStatement(true, getAllowedOutputs('presentation'));
        this.setStyle('dashboards');
        this.setTooltip(Blockly.Msg.TABLE_BLOCK_TOOLTIP);
        this.setOnChange(function () { 
            let compatibility_list = ['analyse_fires_to_land_comparison', 'input_optical_data', 'input_precipitation_data', 'analyse_timeseries', 'input_fire_data', 'input_hansen_forest_change', 'input_land_cover', 'input_biomass', 'analyse_change_detection']
            if (this.getSurroundParent() && (!compatibility_list.includes(this.getSurroundParent().type))){
                this.unplug()
            }
         })
    }
}